(function () {
    'use strict';

    angular
        .module('cacmFollowUpModule', []);
})();
